<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-fm"><a href="#/005_Foreword#fm-1"><em>Foreword</em> by Marlena Graves</a></p>
<p class="toc-fm"><a href="#/006_Preface#fm-2"><em>Preface</em></a></p>
<p class="toc-chapt"><a href="#/007_Chapter01#ch-1">1.<span class="toc">Defining American Christian Nationalism</span></a></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="toc">American Values and Christian Nationalism</span></span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="toc">Christian Values and Christian Nationalism</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="toc">Christian Virtues and Christian Nationalism</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="toc">Christians and the Beloved Community</span></span></p>
<p class="toc-bmt"><span href="#/012_Notes#bm-1" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-bm"><span href="#/013_Bibliography#bm-2" title="Link target outside of Sample"><em>Bibliography</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?ad49e650